import { Brand } from '@blade/std-lib'

export const PremiumIdTypeId = 'tradebot-tma/PremiumId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PremiumIdTypeId = typeof PremiumIdTypeId

export type PremiumId = Brand.Branded<string, PremiumIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PremiumId = Brand.nominal<PremiumId>()
